import type { FunctionComponentWithChildren } from '@bonsai-components/utility-types';
import {
  borderRadius,
  semanticColors,
  shadows,
  spacing
} from '@moderneinc/design-system-tokens';
import { Box } from '@mui/material';
import { toBoxShadow } from '../../helpers/shadow.helper';

export const UnauthenticatedLayout: FunctionComponentWithChildren = ({
  children
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
        background: semanticColors.color.surface.page,
        p: { xs: 2, md: 3 }
      }}
    >
      {/* Soft blue + magenta glow blobs behind the card (morpheus #login). */}
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          width: 700,
          height: 700,
          borderRadius: '50%',
          background:
            'radial-gradient(closest-side, rgba(62, 91, 232, 0.3), transparent 72%)',
          filter: 'blur(70px)',
          transform: 'translate(-170px, -70px)',
          pointerEvents: 'none'
        }}
      />
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          width: 700,
          height: 700,
          borderRadius: '50%',
          background:
            'radial-gradient(closest-side, rgba(230, 57, 155, 0.2), transparent 72%)',
          filter: 'blur(70px)',
          transform: 'translate(190px, 90px)',
          pointerEvents: 'none'
        }}
      />

      {/* Frosted card */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: 470,
          background: semanticColors.color.surface.raisedFrosted,
          backdropFilter: 'blur(26px)',
          border: `1px solid ${semanticColors.color.border.primary}`,
          borderRadius: '18px',
          p: `${spacing.spacing_2_3_4}px`,
          boxShadow: toBoxShadow(shadows.modal)
        }}
      >
        {/* Inner bordered box */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            border: `1px solid ${semanticColors.color.border.subtle}`,
            borderRadius: `${borderRadius.card}px`,
            padding: '74px 44px 58px'
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
